import { MetricCard } from 'components/features/schedule-of-values/metric-card';
import SubmissionCurrencyTab from 'components/features/submission-currency-tabs';
import { DEFAULT_CONVERSION_CURRENCY } from 'components/features/submission-details/types';
import FormLayoutGroup from 'components/ui/form-layout-group';
import FormSection from 'components/ui/form-section';
import { ECurrencies } from 'constants/enums';
import { MasterReserveResponseDto } from 'libs/pinnacle-sdk';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatLocaleNumber } from 'utils/format';

export interface ClaimBinderDetailsProps {
  masterReserve?: MasterReserveResponseDto;
  fguNetIndemnityPayments?: number;
  fguNetCostPayments?: number;
}

const ClaimBinderDetails: React.FC<ClaimBinderDetailsProps> = ({
  masterReserve,
  fguNetIndemnityPayments = 0,
  fguNetCostPayments = 0,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(
    DEFAULT_CONVERSION_CURRENCY
  );

  const fguMarketLossIndemnity = useMemo(() => {
    return masterReserve?.totalFguMarketLossIndemnityExcCosts
      ? Number(masterReserve.totalFguMarketLossIndemnityExcCosts)
      : 0;
  }, [masterReserve]);

  const totalIncurredCosts = useMemo(() => {
    return masterReserve?.totalIncurredCosts
      ? Number(masterReserve.totalIncurredCosts)
      : 0;
  }, [masterReserve]);

  const fguMarketLossOutstandingIndemnity = useMemo(() => {
    return fguMarketLossIndemnity - fguNetIndemnityPayments;
  }, [fguMarketLossIndemnity, fguNetIndemnityPayments]);

  const totalOutstandingCosts = useMemo(() => {
    return totalIncurredCosts - fguNetCostPayments;
  }, [totalIncurredCosts, fguNetCostPayments]);

  return (
    <div>
      <SubmissionCurrencyTab
        originalCurrency={ECurrencies.AUD}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        className="flex justify-end"
      />
      <FormSection
        title={t('claim.binderClaimsActions.claimBinderDetails.title')}
        collapsible
      >
        <FormLayoutGroup mdColumns={2}>
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.fguMarketLossIndemnity'
            )}
            value={formatLocaleNumber(fguMarketLossIndemnity)}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.totalIncurredCosts'
            )}
            value={formatLocaleNumber(totalIncurredCosts)}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.fguNetIndemnityPayments'
            )}
            value={formatLocaleNumber(fguNetIndemnityPayments)}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.fguNetCostPayments'
            )}
            value={formatLocaleNumber(fguNetCostPayments)}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.fguMarketLossOutstandingIndemnity'
            )}
            value={formatLocaleNumber(fguMarketLossOutstandingIndemnity)}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.totalOutstandingCosts'
            )}
            value={formatLocaleNumber(totalOutstandingCosts)}
          />
        </FormLayoutGroup>
      </FormSection>
    </div>
  );
};

export default ClaimBinderDetails;
